import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import {
    MatLegacyPaginatorIntl as MatPaginatorIntl,
    MatLegacyPaginatorModule as MatPaginatorModule,
} from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
    AboutDialogComponent,
    LoginComponent,
    PrivacyPolicyDialogComponent,
    ReadMoreComponent,
    ResultsComponent,
    SelectSecureLocationDialogComponent,
    StatusIconComponent,
    TipComponent,
} from '@app/_components';
import { ConnectionDialogComponent } from '@app/_components/connection-dialog/connection-dialog.component';
import {
    AnimateNumberDirective,
    DomChangeDirective,
    InfolandExpansionPanelDirective,
    PasswordValidatorDirective,
    SameSizeDirective,
    TestAutomationDirective,
} from '@app/_directives';
import { InfolandDate, SanitizeHtmlPipe } from '@app/_pipes';
import { CustomMatPaginator } from '@app/_providers/pagination.provider';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
    providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginator }, CookieService],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatSelectModule,
        MatMenuModule,
        MatBadgeModule,
    ],
    declarations: [
        SanitizeHtmlPipe,
        InfolandDate,
        InfolandExpansionPanelDirective,
        SameSizeDirective,
        PasswordValidatorDirective,
        DomChangeDirective,
        AnimateNumberDirective,
        TestAutomationDirective,
        ResultsComponent,
        LoginComponent,
        TipComponent,
        ReadMoreComponent,
        StatusIconComponent,
        PrivacyPolicyDialogComponent,
        ConnectionDialogComponent,
        AboutDialogComponent,
        SelectSecureLocationDialogComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatStepperModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatBadgeModule,
        TranslateModule,
        SanitizeHtmlPipe,
        InfolandDate,
        InfolandExpansionPanelDirective,
        SameSizeDirective,
        PasswordValidatorDirective,
        AnimateNumberDirective,
        TestAutomationDirective,
        DomChangeDirective,
        ReadMoreComponent,
        ResultsComponent,
        LoginComponent,
        TipComponent,
        StatusIconComponent,
        CdkTableModule,
    ],
})
export class SharedModule {}
